import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-talukawise-subscriber-details-report',
  // standalone: true,
  // imports: [],
  templateUrl: './talukawise-subscriber-details-report.component.html',
  styleUrl: './talukawise-subscriber-details-report.component.scss'
})
export class TalukawiseSubscriberDetailsReportComponent implements OnInit{
  isLoading: boolean = false;
    today = new Date();
  startDate = '';
  endDate = '';
  totalth = 0;
  offrepwiseData;
  //  subTypesName = [
  //   { name: 'वार्षिक', isVisible: false },
  //   { name: 'त्रैवार्षिक', isVisible: false },
  //   { name: 'पंचवार्षिक', isVisible: false },
  // ];
  getSubDetailsReportData: any;
  delivery_mode: any;
  service: any;

  constructor(
      public dialogref: MatDialogRef<TalukawiseSubscriberDetailsReportComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {}


//     subTypesName: {
//   delivery_mode: string;
//   isVisible: boolean;
//   subscriptionTypes: {
//     colCount: any; name: string; isVisible: boolean 
// }[];
// }[] = [];

 getKey(name) {
    return name.replaceAll(' ', '_');
  }

    subTypesName = [
    { name: 'वार्षिक', isVisible: false },
    { name: 'त्रैवार्षिक', isVisible: false },
    { name: 'पंचवार्षिक', isVisible: false },
  ];

  ngOnInit(): void {
// this.isLoading = true;

//   this.getSubDetailsReportData = this.data['getSubDetailsReportData'];
//   this.startDate = this.data['startDate'];
//   this.endDate = this.data['endDate'];

//   this.subTypesName = [];

//   const subTypes = (this.uniqueData(
//     this.getSubDetailsReportData,
//     (a: any) => a.subscription_type
//   ) as any[]).map(a => a.subscription_type);

//   // ✅ GET DELIVERY MODES FROM API
//   this.service.getDeliveryMode().subscribe((deliveryModes: any[]) => {

//     this.delivery_mode = deliveryModes;

//     for (let i = 0; i < deliveryModes.length; i++) {
//       this.subTypesName.push({
//         delivery_mode: deliveryModes[i].delivery_mode, // or name field
//         isVisible: true,
//         subscriptionTypes: subTypes.map(st => ({
//           name: st,
//           isVisible: true
//         }))
//       });
//     }

//     this.totalth = this.subTypesName.filter(d => d.isVisible).length * subTypes.length * 5 + 8;

//     this.isLoading = false;
//     });


  this.isLoading = true;
    this.getSubDetailsReportData = this.data['getSubDetailsReportData'];
    // this.off_rep_name = this.data['off_rep_name'];
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    // console.log(this.offrepwiseData);

    this.appliedFilters = this.data['appliedFilters'] || {};

		console.log("Applied Filters:", this.appliedFilters);

    let data = this.uniqueData(this.getSubDetailsReportData, (a) => a.subscription_type);

    for (let i = 0; i < Object.keys(data).length; i++) {
      let flag = false;
      for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
        if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
          this.subTypesName[j]['isVisible'] = true;
          flag = true;
          break;
        }
      }
      if (!flag) {
        this.subTypesName.push({
          name: data[i]['subscription_type'],
          isVisible: true,
        });
        // }
      }
    }

    // console.log(this.subTypesName);
    // this.totalth = this.subTypesName.length * 5 + 8;
    this.totalth = this.subTypesName.filter(b => b.isVisible).length * 5 + 8;

    // this.getoffdata();
    // this.setData();

    throw new Error('Method not implemented.');

  }
  
  appliedFilters(arg0: string, appliedFilters: any) {
    throw new Error('Method not implemented.');
  }
  
  
// ngOnInit(): void {
//   this.isLoading = true;

//   this.getSubDetailsReportData = this.data['getSubDetailsReportData'] as any[];
//   this.startDate = this.data['startDate'];
//   this.endDate = this.data['endDate'];

//   this.subTypesName = [];

//   /* ---------- UNIQUE SUBSCRIPTION TYPES ---------- */
//   const subTypes: string[] = (
//     this.uniqueData(
//       this.getSubDetailsReportData,
//       (a: any) => a.subscription_type
//     ) as any[]
//   ).map(a => a.subscription_type as string);

//   /* ---------- UNIQUE DELIVERY MODES (STRING ONLY) ---------- */
//   const usedDeliveryModes: string[] = Array.from(
//     new Set(
//       this.getSubDetailsReportData
//         .map((a: any) => a.delivery_mode)
//         .filter((m: any) => typeof m === 'string' && m.trim() !== '')
//     )
//   );

//   /* ---------- BUILD STRUCTURE ---------- */
//   for (let i = 0; i < usedDeliveryModes.length; i++) {

//     const mode: string = usedDeliveryModes[i];

//     this.subTypesName.push({
//       delivery_mode: mode, // ✅ now strictly string
//       isVisible: true,
//       subscriptionTypes: subTypes.map((st: string) => ({
//         name: st,
//         isVisible: true,
//         colCount: this.getSubDetailsReportData.filter(
//           (d: any) =>
//             d.delivery_mode === mode &&
//             d.subscription_type === st
//         ).length
//       }))
//     });
//   }

//   /* ---------- DYNAMIC HEIGHT ---------- */
//   this.totalth = this.subTypesName
//     .filter(d => d.isVisible)
//     .reduce((height, d) => {
//       const cols = d.subscriptionTypes.reduce(
//         (sum, s) => sum + (s.colCount > 0 ? s.colCount : 0),
//         0
//       );
//       return height + cols * 5;
//     }, 8);

//   this.isLoading = false;
// }



   uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }






 exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }


    show = false
  printPage() {
    this.show = true
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
      console.error("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
             <html>
                 <head>
                     <title>Print Report</title>
                     <style>
                         @media print {
                             @page { 
                                 size: A3 landscape; /* Set A3 size with landscape mode */
                                 margin: 5mm; /* Adjust margins */
                             }
                             body { 
                                 font-family: Arial, sans-serif; 
                                 font-size: 15px; /* Adjust font size */
                                 margin: 0; 
                                 padding: 5mm; 
                                 line-height: 1.2; 
                             }
                             table { 
                                 width: 100%; 
                                 height: 100%;
                                 border-collapse: collapse; 
                                 table-layout: fixed; /* Prevent column expansion */
                                 page-break-inside: avoid; /* Avoid breaking the table */
                             }
                             th, td { 
                                 padding: 2px; 
                                 border: 1px solid black; 
                                 text-align: center; 
                                 font-size: 14px; /* Adjusted font size */
                                 line-height: 1.2; 
                             }
                             .noPrint { 
                                 display: none; /* Hide print button */
                             }
                         }
                     </style>
                 </head>
                 <body>
                     <div id="print-section">
                         ${printContent}
                     </div>
                     <script>
                         window.onload = function() { 
                             window.print(); 
                             setTimeout(() => { window.close(); }, 500);
                         };
                     </script>
                 </body>
             </html>
         `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }

}
